<script lang="ts">
   import Camera from "simple-vue-camera";
   import {computed, ref} from "vue";
   import axios from "axios";
   import { useStore } from 'vuex'
   import { useRouter } from 'vue-router'
   import {useToast} from "primevue/usetoast";
   import {Ds_Cls} from "@/models/ds_Cls";
   import zaloRepository from "@/services/ZaloRepository";
   import moment from "moment";
   import {ThongTinBN} from "@/models/thongTinBN";

   export default {
  setup(){
    const camera = ref<InstanceType<typeof Camera>>();
    const lat = ref(0);
    const long = ref(0);
    const toast = useToast();
    const checkin = ref(false);
    const loadingBar = ref(false);
    const cameraPermission = ref(true);
    const store = useStore();
    const url = ref();

    const listBlob = ref([] as string[]);
    const listUrl = ref([] as string[]);
    const maYTe = ref("");
    const thongTinBN = ref({} as ThongTinBN);
    const ngaySinh = ref("");

    const loadListCls = () => {
      zaloRepository.getThongTinBN(maYTe.value)
          .then((response) => {
            thongTinBN.value = response.data;
            if(thongTinBN.value != null)
            {
              ngaySinh.value = formatDate(thongTinBN.value.ngaysinh);
            }
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tìm thông tin bệnh nhân',
              life: 2000
            });
          });
    }

    const formatDateTime = (date) => {
      console.log("@@@@@@@@@################ formatDateTime date: " + date.value);
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('HH:mm:ss DD/MM/YYYY');
    };

    const formatDate = (date) => {
      console.log("@@@@@@@@@################ formatDateTime date: " + date.value);
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('DD/MM/YYYY');
    };

    const snapshot = async () => {
      const blob = ref();
      if(camera.value != null)
      {
        if (camera.value?.resolution.width < camera.value?.resolution.height) {
          blob.value = await camera.value?.snapshot(
              {width: 540, height: 960},
              "image/jpeg",
              0.5
          );
        } else {
          blob.value = await camera.value?.snapshot(
              {width: 960, height: 540},
              "image/jpeg",
              0.5
          );
        }
      }

      console.log("######## height: " + JSON.stringify(camera.value?.resolution));

      // To show the screenshot with an image tag, create a url
       url.value = URL.createObjectURL(blob.value);
      if(url.value != null) {
        console.log("######################## url.value: " + url.value);
        listUrl.value.push(url.value);
        listBlob.value.push(blob.value);
        console.log("######################## listUrl.value: " + JSON.stringify(listUrl.value));
      }
    }

    function base64ToBlob(base64: string, mime = 'image/jpeg'): Blob {
      const byteString = atob(base64.split(',')[1]);
      const byteArray = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i);
      }
      return new Blob([byteArray], { type: mime });
    }

    const uploadImage = () => {

      // open(url);
      var files = new FormData();
      if(listBlob?.value.length > 0) {
        listBlob.value.forEach(x => {
          const blob = base64ToBlob(x); // x là base64 string
          const urlTemp = URL.createObjectURL(blob);
          const str = urlTemp.split('/');
          //const blobFile = new File([x], str[str.length - 1] + '.jpeg');
          files.append("formFiles", new Blob([x], { type: 'image/jpeg' }),str[str.length - 1] + '.jpeg');
        })
        axios.defaults.headers.common = {'Authorization': `Bearer ${store.state.token}`}
        {
          if(!cameraPermission.value){
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:"Vui lòng bật quyền truy cập máy ảnh(camera) và thực hiện lại",
              life: 4000
            });
          }
          else {
            loadingBar.value = true;
            axios.post(`/api/file/UploadFacePatient/${maYTe.value}`, files,
                {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data'
                  }
                }).then(response => {
              loadingBar.value = false;
              toast.add({
                severity: 'success',
                summary: 'Thành công',
                detail:'Tải ảnh lên thành công',
                life: 2000
              });
              listBlob.value = [];
              listUrl.value = [];
              const temp = ref({} as ThongTinBN);
              thongTinBN.value = temp.value;
              maYTe.value = "";
            })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail:err.response.data,
                    life: 2500
                  })});
          }
        }
      }
    }

    const error = (error: Error) => {
      cameraPermission.value = false;
    };

    const deleteImage = (id) => {
      const index = ref(0);
      listUrl.value.forEach( x => {
        if(x == id) {
          listUrl.value.splice(index.value, 1);
          listBlob.value.splice(index.value, 1);
        }
        else
        {
          index.value++;
        }
      })
    }

    return {
      camera,
      snapshot,
      lat,
      long,
      checkin,
      loadingBar,
      error,
      url,
      listUrl,
      deleteImage,
      uploadImage,
      loadListCls,
      thongTinBN,
      ngaySinh,
      maYTe,
      listBlob,
      // blobPhoto
    };

  }
}
</script>

<template>
  <div class="p-fluid">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col p-col-12 p-md-12 p-lg-12">
        <Panel header="Hệ thống đăng ký sinh trắc học bệnh nhân" style="padding-bottom: -10px">
          <div>
          <div class="p-fluid">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col p-col-12 p-md-12 p-lg-3" style="font-size: 16px">
                <Panel header="Tra cứu bệnh nhân">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col p-col-12 p-md-6 p-lg-6">
                      <label style="font-size: 16px">Mã y tế</label>
                      <InputText id="name" type="text" v-model="maYTe" style="text-align: center;font-size: 16px"/>
                    </div>
                    <div class="p-field p-col p-col-12 p-md-6 p-lg-6">
                      <label style="font-size: 16px">Tra cứu</label>
                      <Button label="Tìm" icon="pi pi-plus-circle" iconPos="left" @click="loadListCls()" style="font-size: 16px"/>
                    </div>
                  </div>
                </Panel>
              </div>
              <div class="p-field p-col p-col-12 p-md-12 p-lg-9" style="font-size: 16px">
                <Panel header="Thông tin bệnh nhân" v-if="thongTinBN.tenbenhnhan != null">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col p-col-12 p-md-3 p-lg-6">
                      <label style="font-size: 16px">Họ và tên</label>
                      <InputText id="hoVaTen" type="text" v-model="thongTinBN.tenbenhnhan" style="text-align: center;font-size: 16px" disabled/>
                    </div>
                    <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
                      <label style="font-size: 16px">Ngày sinh</label>
                      <InputText id="ngaySinh" v-model="ngaySinh" type="text" style="text-align: center;font-size: 16px" disabled>
                      </InputText>
                    </div>
                    <div class="p-field p-col p-col-12 p-md-4 p-lg-3">
                      <label style="font-size: 16px">Số điện thoại</label>
                      <InputText id="dt" type="text" v-model="thongTinBN.sodienthoai" style="text-align: center;font-size: 16px" disabled/>
                    </div>
                  </div>
                </Panel>
              </div>
              <div class="p-field p-col p-col-12 p-md-12 p-lg-12" v-if="thongTinBN.tenbenhnhan != null">
      <!--          <Panel>-->
                  <div class="p-fluid">
                    <div class="p-fluid p-formgrid p-grid">
                      <div class="p-field p-col-12 p-md-12">
      <!--                  <Label>{{long}} , {{lat}}</Label>-->
                        <div style="margin: auto;width: 30%">
                          <camera :resolution="{ width: 480, height: 270 }" :facingMode="{ exact: user }" ref="camera" @error="error" autoplay></camera>
      <!--                    <br>-->
                          <Button @click="snapshot" label="Chụp hình" icon="pi pi-camera" style="font-weight: bold;" severity="success" raised />
                        </div>
                        <div class="p-fluid">
                          <div class="p-fluid p-formgrid p-grid">
                            <li v-for="x in listUrl">
                              <div class="p-field p-col-3 p-md-3">
                                <Card style="width: 10rem; overflow: hidden">
                                  <template #header>
                                    <img id="image" :src="x" style="width: 10rem;"/>
                                  </template>
                                  <template #footer>
<!--                                    <div class="flex gap-3 mt-1">-->
<!--                                      <Button label="Cancel" severity="secondary" outlined class="w-full" />-->
                                      <Button label="Xóa" class="w-full" @click="deleteImage(x)" icon="pi pi-trash" severity="danger" />
<!--                                    </div>-->
                                  </template>
                                </Card>
                              </div>
                            </li>
                          </div>
                        </div>
                      </div>
                      <div class="p-field p-col-12 p-md-12">
                        <div class="p-fluid">
                          <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-md-12" v-if="listBlob?.length > 0">
                              <div style="width: 100px;margin: auto;width: 40%">
                                <Button label="Đăng hình" class="w-full" @click="uploadImage()" icon="pi pi-upload" severity="info" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
      <!--          </Panel>-->
              </div>
            </div>
        </div>
      </div>
      </Panel>
      </div>
      <div class="p-field p-col p-col-12 p-md-12 p-lg-12" id="scroll-container">
        <div id="scroll-text" style="align-items: center; width: 150%">
<!--          <img class="background" src="../assets/logoNHS.png" style="width: 40px;height: 40px;">-->
          <br>
          <label style="color: #3e9cba; font-size: 20px; ">
            BỆNH VIỆN Y HỌC CỔ TRUYỀN THÀNH PHỐ ĐÀ NẴNG
          </label>
        </div>
      </div>
      <div class="p-field p-col-12 p-sm-12 p-md-12">
        <Dialog header="Đăng hình lên " v-model:visible="loadingBar" >
          <div id="loading">
            <label>Hệ thống đang xử lý, vui lòng chờ trong giây lát ...</label>
            <ProgressBar mode="indeterminate" style="height: .3em" />
          </div>
        </Dialog>
        <ConfirmDialog></ConfirmDialog>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#scroll-container {
  border-radius: 5px;
  overflow: hidden;
}

#scroll-text {
  /* animation properties */
  -moz-transform: translateX(100%);
  -webkit-transform: translateX(100%);
  transform: translateX(100%);

  -moz-animation: my-animation 15s linear infinite;
  -webkit-animation: my-animation 15s linear infinite;
  animation: my-animation 15s linear infinite;
}

/* for Firefox */
@-moz-keyframes my-animation {
  from { -moz-transform: translateX(100%); }
  to { -moz-transform: translateX(-100%); }
}

/* for Chrome */
@-webkit-keyframes my-animation {
  from { -webkit-transform: translateX(100%); }
  to { -webkit-transform: translateX(-100%); }
}

@keyframes my-animation {
  from {
    -moz-transform: translateX(100%);
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }
  to {
    -moz-transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}

.p-panel-content {
  padding: 5px;
  box-sizing: border-box;
}
</style>